<template>
  <div class="form-group">
    <slot name="label">
      <label
        v-if="label"
        class="control-label">
        {{ label }}
      </label>
    </slot>
    <div class="date-picker-wrapper">
      <el-date-picker
        :value="value"
        type="date"
        class="form-control"
        placeholder="Pick a Date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseRadio',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      description: 'Input label'
    },
    value: {
      type: String,
      description: 'Input value'
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
